import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    width: "calc(100% - 32px)",
    maxWidth: "620px",
    margin: "16px",
    borderRadius: "18px",
    overflow: "hidden",
  },

  popupWrapper: {
    position: "relative",
    padding: "28px",
    background: "#FFFFFF",
  },

  closeButton: {
    position: "absolute",
    top: "12px",
    right: "14px",
    width: "32px",
    height: "32px",
    border: "none",
    borderRadius: "50%",
    background: "#F5F5F5",
    color: "#555555",
    fontSize: "24px",
    lineHeight: "28px",
    cursor: "pointer",
    padding: 0,

    "&:hover": {
      background: "#EEEEEE",
    },
  },

  popupHeader: {
    textAlign: "center",
    padding: "4px 40px 22px",
  },

  popupHeading: {
    margin: 0,
    color: "#212121",
    fontSize: "24px",
    lineHeight: "30px",
    fontWeight: 700,
  },

  popupSubHeading: {
    margin: "6px 0 0",
    color: "#777777",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 500,
  },

  groupGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "12px",

    maxHeight: "430px",
    overflowY: "auto",

    padding: "2px 4px 4px 2px",

    msOverflowStyle: "none",
    scrollbarWidth: "none",

    "&::-webkit-scrollbar": {
      display: "none",
    },
  },

  groupCard: {
    width: "100%",
    minHeight: "72px",
    display: "flex",
    alignItems: "center",
    textAlign: "left",

    padding: "12px",
    border: "1px solid #E5E5E5",
    borderRadius: "12px",

    background: "#FFFFFF",

    cursor: "pointer",

    transition: "all 0.2s ease",

    "&:hover": {
      borderColor: "#25D366",
      background: "#F8FFF9",
      transform: "translateY(-1px)",
    },

    "&:disabled": {
      cursor: "default",
      opacity: 0.7,
    },
  },

  groupWhatsappIcon: {
    width: "24px",
    height: "24px",
    objectFit: "contain",
    flexShrink: 0,
    marginRight: "10px",
  },

  groupContent: {
    minWidth: 0,
    flex: 1,
  },

  groupName: {
    color: "#212121",
    fontSize: "14px",
    lineHeight: "19px",
    fontWeight: 600,

    whiteSpace: "normal",
    wordBreak: "break-word",
  },

  sportName: {
    marginTop: "4px",
    color: "#ff4e00",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 500,
  },

  noGroups: {
    textAlign: "center",
    padding: "24px 10px",
    color: "#777777",
    fontSize: "14px",
  },

  "@media (max-width: 550px)": {
    dialogPaper: {
      width: "calc(100% - 24px)",
      margin: "12px",
      maxWidth: "none",
      borderRadius: "16px",
    },

    popupWrapper: {
      padding: "22px 16px",
    },

    popupHeader: {
      padding: "4px 34px 18px",
    },

    popupHeading: {
      fontSize: "20px",
      lineHeight: "26px",
    },

    popupSubHeading: {
      fontSize: "12px",
      lineHeight: "17px",
    },

    groupGrid: {
      gap: "8px",
      maxHeight: "55vh",
    },

    groupCard: {
      minHeight: "68px",
      padding: "10px 8px",
    },

    groupWhatsappIcon: {
      marginRight: "8px",
    },

    groupName: {
      fontSize: "12px",
      lineHeight: "17px",
    },

    sportName: {
      fontSize: "11px",
      lineHeight: "15px",
      marginTop: "3px",
    },
  },
}));

export default useStyles;
